<template>
    <div>
        <div class="row">
            <div class="col-lg-6 col-12 mt-3">
                <div class="title h-100">
                    <i class="fa fa-arrow-left fa-2x mr-3" @click="$router.push({name : 'StockOpname'})"></i> 
                    <h3 class="mb-0">Request Opname</h3>
                </div>
            </div>
            <div class="offset-lg-4 col-lg-2 col-6 mt-3 pr-4">
                    <div class="row bg-white  pt-1 pb-1">
                        <div class="col-lg-7 nova-medium col-7 flex-middle">
                            Multiple Select
                        </div>
                        <div class="col-lg-5 col-5 pt-1">
                            <ToggleButton
                                :color="'#134F97'"
                                v-model="multiple"
                            />
                        </div>
                    </div>
                   
            </div>
        </div>

        <!-- {{ $options.dealerList }} -->

        <div class="bg-white mt-4 p-30 rounded">
            <div class="row">
                <div class="col-6 pl-5 mt-2" :class="{'col-lg-4' : !multiple , 'col-lg-6' : multiple}">
                    <div class="row">
                        <div class="text-left mt-auto mb-auto" :class="{'col-5' : !multiple , 'col-4' : multiple}">
                            Pilih Dealer<br>
                            <span style="font-size: 10px;color : #608BBE">( Isi 2 Karakter Untuk Search )</span>
                        </div>
                        <div :class="{'col-7' : !multiple , 'col-8' : multiple}">
                            <Multiselect 
                                v-model="data.dealer"
                                :options="$options.dealerList.map(x => x.loc_code)"
                                :custom-label="opt => $options.dealerList.find(x => x.loc_code == opt).showName"
                                placeholder="Pilih Dealer"
                                :preserveSearch="true"
                                :close-on-select="!multiple"
                                :multiple="multiple"
                            />
                        </div>
                    </div>
                </div>
                <div class="col-6 mt-2" :class="{'col-lg-4' : !multiple , 'col-lg-6 pr-5' : multiple}">
                    <div class="row">
                        <div class="col-4 text-center mt-auto mb-auto">
                            Durasi<br>
                            <span style="font-size: 10px;color : #608BBE">(Jam , Menit)</span>
                        </div>
                        <div class="col-8">
                            <div class="row">
                                <div class="col-6">
                                    <input type="text"
                                        v-model="durasi.jam"
                                        class="form-control"
                                        placeholder="Jam"
                                    />
                                </div>
                                <div class="col-6">
                                    <input type="text"
                                        v-model="durasi.menit"
                                        class="form-control"
                                        placeholder="Menit"
                                    />
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-6 mt-2 pr-5" v-if="!multiple">
                    <div class="row">
                        <div class="col-4 text-center mt-auto mb-auto">
                            PIC<br>
                            <span style="color:#608BBE;font-size:10px">(Opsional)</span>
                        </div>
                        <div class="col-8">
                            <!-- <input type="text"
                                v-model="data.pic"
                                class="form-control"
                            /> -->
                            <Multiselect 
                                v-model="data.pic"
                                :options="userDealerList.map(x => x.id)"
                                :custom-label="opt => userDealerList.find(x => x.id == opt).name"
                                placeholder="Pilih PIC"
                                :multiple="true"
                            />
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-4 pl-5 mt-4">
                    <div class="row">
                        <div class="col-5 text-left mt-auto mb-auto">
                            Lokasi
                        </div>
                        <div class="col-7">
                            <input type="text"
                                v-model="data.lokasi"
                                class="form-control"
                            />
                        </div>
                    </div>
                </div>
                <!-- <div class="col-lg-2"></div> -->
                <div class="col-lg-4 col-4 mt-4">
                    <div class="row">
                        <div class="col-4 text-center mt-auto mb-auto">
                            Pilih Tanggal
                        </div>
                        <div class="col-8">
                            <flat-pickr
                                :config="rangePickr"
                                placeholder="Select Date"
                                v-model="data.tgl_request"
                            ></flat-pickr>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-4 pr-5 mt-4">
                    <div class="row">
                        <div class="col-4 text-center mt-auto mb-auto">
                            Pilih Jam<br>
                            <span style="font-size: 10px;color : #608BBE">(Jam , Menit)</span>
                        </div>
                        <div class="col-8">
                            <div class="row">
                                <div class="col-6">
                                    <input type="text"
                                        v-model="jam.jam"
                                        class="form-control"
                                        placeholder="Jam"
                                    />
                                </div>
                                <div class="col-6">
                                    <input type="text"
                                        v-model="jam.menit"
                                        class="form-control"
                                        placeholder="Menit"
                                    />
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
            <hr class="mt-5">

            <div class="row pl-3 pr-3" v-if="selectVehicle" :class="{'mt-5' : data.dealer , 'mt-3' : !data.dealer} "> <!-- Cari Unit -->
                <div class="col-12 mb-4 text-center" v-if="!data.dealer">
                    <span style="color:red;font-size: 14px;">Mohon diisi dealer terlebih dahulu untuk mulai pemilihan unit kendaraan.</span>
                </div>
                <div class="col-lg-1 col-3 mt-auto mb-auto text-center">
                    Cari Unit
                </div>
                <div class="col-lg-3 col-9">
                    <input type="text"
                        class="form-control"
                        v-model="search"
                    />
                </div>

                <div class="offset-lg-4 col-lg-2 col-6 mt-auto mb-auto">
                    <i class="fa fa-angle-left fa-lg mr-3" @click="changePage('-')"></i><span class="h5">{{(curPage - 1) * showLimit + 1}} - {{(curPage - 1) * showLimit + showLimit < totalDataLength ? (curPage - 1) * showLimit + showLimit : totalDataLength}} of {{totalDataLength}}</span><i class="fa fa-angle-right fa-lg ml-3" @click="changePage('+')"></i>
                </div>
                <div class="col-lg-2 col-6">
                    <Multiselect 
                        v-model="showLimit"
                        :options="[25 , 50 , 75 , 100]"
                        :custom-label="opt => 'Show ' + opt"
                    />
                </div>
            </div>

            <div class="row mt-5" v-if="selectVehicle">
                <div class="col-lg-2 col-0"></div>
                <div class="col-lg-10 col-12">
                    <table class="table">
                        <thead>
                            <th>
                                <input type="checkbox" v-model="checkAll" />&nbsp;&nbsp;&nbsp;<i class="fa fa-angle-down fa-lg"></i>
                            </th>
                            <!-- <th>Photo</th> -->
                            <th>Unit</th>
                            <th>Warna</th>
                            <th>Total Unit</th>
                            <th class="text-center"><i class="fa fa-cog"></i></th>
                        </thead>
                        <tbody v-for="singleData in showStock.slice((curPage - 1) * showLimit , (curPage - 1) * showLimit + showLimit)">
                            <tr>
                                <td><input type="checkbox" v-model="checked" :value="singleData"/></td>
                                <td>{{singleData.type_desc ? singleData.type_desc : singleData.type_code}}</td>
                                <td>{{singleData.color_desc ? singleData.color_desc : singleData.color_code}}</td>
                                <td><input type="text" class="form-control" style="height:34px;" v-model="singleData.total_unit"/></td>
                                <td>
                                    <button
                                        class="btn w-100 color-space-blue"
                                        @click="showDetailUnit(singleData)"
                                    >
                                        Lihat Detail
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="row mt-5 pl-3 pr-3"> <!-- Button Bottom -->
                <div class="col-lg-2 col-6">
                    <template v-if="!multiple">
                        <button
                            v-if="selectVehicle"
                            @click="selectVehicle = false"
                            class="btn btn-dark-blue-outline w-100"
                        >
                            Batalkan Pilih Kendaraan
                        </button>
                        <button
                            v-else
                            @click="selectVehicle = true"
                            class="btn btn-dark-blue-outline w-100"
                        >
                            Pilih Kendaraan
                        </button>
                    </template>
                </div>

                <div class="offset-lg-7 col-lg-3 col-6">
                    <div class="row">
                        <div class="col">
                            <button
                                class="btn btn-dark-blue-outline w-100"
                                @click="$router.push({name : 'StockOpname'})"
                            >
                                Batal
                            </button>
                        </div>
                        <div class="col">
                            <button
                                class="btn btn-dark-blue w-100"
                                @click="submitForm(false)"
                            >
                                Kirim Perintah
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <detailUnitTable 
            v-if="detailList"
            :detailList="detailList"
            :tableHeader="tableHeader"
            @closeModal="detailList = null"
        />

        <showConfirmationModal
            v-if="modal.showConfirmation"
            @closeModal="modal.showConfirmation = false;sendData = null"
            @submit="modal.showConfirmation = false;submitForm(true)"
            :data="sendData"
            @removeDealer="removeDealer"
        />
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import detailUnitTable from './children/detailUnitTable.vue'
import moment from 'moment'
import debounce from 'debounce'
import { ToggleButton } from 'vue-js-toggle-button'
import showConfirmationModal from './children/showConfirmationModal.vue'

export default {
    metaInfo : {
        title : 'Request Opname'
    },
    components : {
        Multiselect,
        detailUnitTable,
        ToggleButton,
        showConfirmationModal
    },
    created () {
        this.$options.dealerList = this.$store.getters.getFilterOptions.dealer
        // console.log(this.$options.dealerList)
    },
    dealerList : null,
    watch : {
        checkAll : function () {
            if(this.checkAll) {
                this.checked = this.dealerStock.slice()
            }
            else {
                this.checked.length = 0;
            }
        },
        'data.dealer' : function () {
            this.loadDealerStock()
            this.loadUserDealer()
            this.data.pic = []
        },
        search : function () {
            this.debounceMethod(this.search , this)
        },
        multiple : function () {
            this.search_unit = ''
            this.data.pic = []
            this.data.dealer = null
            this.selectVehicle = false
        }
    },
    mounted () {
        // this.loadDealerStock()
    },
    data () {
        let today = new moment().format('Y-MM-DD');

        return {
            data : {
                dealer : null,
                durasi : null,
                pic : [],
                lokasi : null,
                tgl_request : today
            },
            durasi : {
                jam : '',
                menit : ''
            },
            jam : {
                jam : '',
                menit : ''
            },
            options : {
                status : this.$store.getters.getStatus,
                pic : [],
                dealer : []
            },
            selectVehicle : false,
            dealerStock : [],
            totalDataLength : 0,
            curPage : 1,
            showLimit : 50,
            search : '',
            checked : [],
            detailList : null,
            tableHeader : null,
            rangePickr: {
                dateFormat: "Y-m-d",
                altInput: true,
                altFormat: "M d, Y",
                altInputClass: 'form-control input elegant-flatpickr'
            },
            modal : {
                showConfirmation : false
            },
            showStock : [],
            checkAll : false,
            userDealerList : [],
            multiple : false,
            sendData : null
        }
    },
    methods : {
        removeDealer(index) {
            this.data.dealer.splice(index, 1);
        },
        async searchDealer (query) {
            let dealerList = await this.$store.getters.getDealer()
            dealerList = dealerList.filter(x => x.showName.toLowerCase().includes(query.toLowerCase()) && query.length > 1)
            this.options.dealer = dealerList
        },
        async loadUserDealer() {
            try {
                let response = await this.$http.get('/api/user-dealer?dealer=' + this.data.dealer)

                let data = response.data.data
                this.userDealerList = data
            }
            catch(err) {
                console.log(err)
            }
        },
        async loadDealerStock (search = null) {
            try {
                let url = '/api/get-stock-unit?dealer=' + this.data.dealer
                if(search) 
                    url += '&search_unit=' + search

                console.log(search)
                let response = await this.$http.get(url)

                let data = response.data.data
                // data = data.map(x => {
                //     return {
                //         ...x,
                //         max_stock : x.total_unit
                //     }
                // })


                this.dealerStock = data
                this.showStock = data
                this.totalDataLength = data.length;
                this.curPage = 1
                this.checked = []
            }
            catch(err) {
                console.log(err)
            }
        },
        changePage (changeType) {
            if(changeType == '-') {
                if(this.curPage == 1)
                    return;
                
                this.curPage--;
            }
            else {

                if((this.curPage - 1) * this.showLimit + this.showLimit >= this.totalDataLength)
                    return
                
                this.curPage++;
            }
        },
        async showDetailUnit (unit) {
            try {
                let url = `/api/detail-stock-unit?dealer=${this.data.dealer}&type=${unit.type_code}&color=${unit.color_code}`

                if(this.search)
                    url += `&search_unit=${this.search}`

                let response = await this.$http.get(url)

                let data = response.data.data

                for(var i = 0; i < data.length ; i++) {
                    data.aging = data.aging + ' Hari'
                }

                this.detailList = data
                this.tableHeader = unit;
            }
            catch(err) {
                console.log(err)
            }
        },
        debounceMethod : debounce((value , vm) => {
            // if(vm.search == ''){
            //     vm.totalDataLength = vm.dealerStock.length
            //     vm.showStock = vm.dealerStock
            // }
                
            // else{
            //     let filteredData = vm.dealerStock.filter(x => x.type_desc.toLowerCase().includes(vm.search.toLowerCase()))
            //     vm.showStock = filteredData
            //     vm.totalDataLength = filteredData.length
            // }
            vm.loadDealerStock(value)
        } , 100),
        async submitForm (confirm = false) {
            let data = JSON.parse(JSON.stringify(this.data));
            data.unit = await this.transformCheck()
            if(!data.unit) delete data.unit
            if(this.search) data.search_unit = this.search
            if(this.multiple) data.multiple = this.multiple

            
            // PIC Check
            if(data.pic.length == 0) delete data.pic
            else data.pic = data.pic.join(',')

            

            // console.log(data)

            if(this.validateForm(data)) {
                // console.log(this.data)
                data.durasi = parseInt(this.durasi.jam) * 60 + parseInt(this.durasi.menit)
                data.tgl_request = new moment(data.tgl_request).set('hour' , this.jam.jam).set('minute' , this.jam.menit).format('Y-MM-DD HH:mm:ss')

                if(!confirm && this.multiple) {
                    this.modal.showConfirmation = true
                    this.sendData = data
                    return
                }

                if(Array.isArray(data.dealer))
                    data.dealer = data.dealer.join(',')

                this.$http.post('/api/request-opname' , data)
                .then((resp) => {
                    this.$swal.fire({
                        title :'Sucess!',
                        text : 'Request Opname berhasil tercatat',
                        icon : 'success'
                    })
                    // console.log(resp.data.data)
                    this.$router.push({name : 'StockOpname'})
                })
                .catch((err) => {
                    console.log(err)
                })
            }
        },
        transformCheck () {

            if(this.selectVehicle || this.multiple) {
                if(this.checked.length == 0) {
                    return null
                }
                return this.checked.map((x) => {
                    return {
                        "type_code" : x.type_code,
                        "type_desc" : x.type_desc,
                        "color_code" : x.color_code,
                        "color_desc" : x.color_desc,
                        "qty" : x.total_unit
                    }  
                })
            }
            else {
                return null
            }
            
        },
        validateForm (form) {
            let error = []

            if(!form.dealer) {
                error.push('Dealer tidak boleh kosong!')
            }

            if(!this.durasi.jam) {
                error.push('Jam Durasi tidak boleh kosong!')
            }
            else {
                if(isNaN(this.durasi.jam)) {
                    error.push('Durasi Jam harus berbentuk angka!')
                }
            }

            if(!this.durasi.menit) {
                error.push('Menit Durasi tidak boleh kosong!')
            }
            else {
                let menit = parseInt(this.durasi.menit);
                if(isNaN(this.durasi.menit)) {
                    error.push('Menit Durasi harus berbentuk angka!')
                }
                else if(menit < 0 || menit  > 60) {
                    error.push('Menit Durasi tidak boleh lebih kecil dari 0 atau diatas 60')
                }
            }

            if(!this.jam.jam) {
                error.push('Jam Mulai tidak boleh kosong!')
            }
            else {
                if(isNaN(this.jam.jam)) {
                    error.push('Jam Mulai harus berbentuk angka!')
                }
            }

            if(!this.jam.menit) {
                error.push('Menit Jam tidak boleh kosong!')
            }
            else {
                let menit = parseInt(this.jam.menit);
                if(isNaN(this.jam.menit)) {
                    error.push('Menit Jam harus berbentuk angka!')
                }
                else if(menit < 0 || menit  > 60) {
                    error.push('Menit Jam tidak boleh lebih kecil dari 0 atau diatas 60')
                }
            }

            let curDate = new moment()
            let requestDate = new moment(form.tgl_request).set({hour: parseInt(this.jam.jam) ,minute: parseInt(this.jam.menit) ,second:0,millisecond:0})

            if(!requestDate.isSameOrAfter(curDate)) {
                error.push('Tanggal Opname tidah boleh lebih kecil dari waktu sekarang')
            }

            if(this.selectVehicle && !form.unit) {
                error.push('Unit untuk opname tidak boleh kosong!')
            }

            // Check if Any Vehicle is more than the limit total_unit
            // Remove this validation -  Marvin 30 Jan 2023
            // if(this.selectVehicle) {
            //     let maxUnitMore = this.checked.filter(x => x.total_unit > x.max_stock)
                
            //     if(maxUnitMore.length > 0) {
                    
            //         error.push(`${maxUnitMore[0].type_desc} Dengan Warna ${maxUnitMore[0].color_desc} Melebihi Maximum Unit Stock Tersedia`);
            //     }
            // }

            if(error.length > 0) {
                this.$swal.fire({
                    title: 'Error!',
                    text: error[0],
                    icon: 'error',
				})
                return false
            }
            else {
                return true
            }
        }
    }
}
</script>

<style scoped>
    .flex-middle {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .nova-medium {
        font-family: 'Proxima Nova Bold';
    }
</style>

<style>
    .multiselect__tag {
        max-width: 95px;
    }
</style>